/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./orders-loader";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
import * as i4 from "../services";
import * as i5 from "../../../globals";
import * as i6 from "ionic-angular/components/loading/loading-controller";
import * as i7 from "../../configuration/services";
import * as i8 from "../../takeaway/services";
import * as i9 from "../../tpv/services";
var styles_OrdersLoaderPage = [];
var RenderType_OrdersLoaderPage = i0.ɵcrt({ encapsulation: 2, styles: styles_OrdersLoaderPage, data: {} });
export { RenderType_OrdersLoaderPage as RenderType_OrdersLoaderPage };
export function View_OrdersLoaderPage_0(_l) { return i0.ɵvid(0, [], null, null); }
export function View_OrdersLoaderPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-orders-loader", [], null, null, null, View_OrdersLoaderPage_0, RenderType_OrdersLoaderPage)), i0.ɵdid(1, 49152, null, 0, i1.OrdersLoaderPage, [i2.NavController, i3.NavParams, i4.OrdersCoServices, i5.Globals, i6.LoadingController, i7.ConfigurationServices, i8.TakeawayServices, i9.TPVServices], null, null)], null, null); }
var OrdersLoaderPageNgFactory = i0.ɵccf("page-orders-loader", i1.OrdersLoaderPage, View_OrdersLoaderPage_Host_0, {}, {}, []);
export { OrdersLoaderPageNgFactory as OrdersLoaderPageNgFactory };
//# sourceMappingURL=orders-loader.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/orders/orders-loader/orders-loader.ngfactory.js
// module id = null
// module chunks = 